export default "__VITE_ASSET__Cku5o$qA__"